import { Tooltip } from "react-tooltip";
import { Info } from "lucide-react";
import React from "react";
import "./tooltip.css";

const InfoTooltip = ({ index, content, title }) => {
  // Function to convert React elements to HTML string
  const convertToHtml = (reactContent) => {
    if (typeof reactContent === 'string') {
      return reactContent;
    }
    
    // If it's a React element or array of elements
    if (React.isValidElement(reactContent) || Array.isArray(reactContent)) {
      // Create a temporary div to render the React content
      const tempDiv = document.createElement('div');
      
      // Use ReactDOM to render the content to a string
      const ReactDOM = require('react-dom/server');
      const htmlString = ReactDOM.renderToStaticMarkup(
        Array.isArray(reactContent) ? <>{reactContent}</> : reactContent
      );
      
      return htmlString;
    }
    
    return '';
  };
  
  // Convert content to HTML string
  const contentHtml = convertToHtml(content);
  
  // Create the tooltip HTML content with title if provided
  const tooltipHtml = title ? 
    `<div class='tooltip-title'>${title}</div>${contentHtml}` : 
    contentHtml;
  
  return (
    <>
      <div className="info-tooltip">
        <Info
          data-tooltip-id="my-tooltip"
          data-tooltip-html={tooltipHtml}
          size={16}
        />
      </div>
      <Tooltip
        id="my-tooltip"
        className="custom-tooltip"
        place="right"
        html={true}
        clickable={true}
        float={true}
        zIndex={9999}
        style={{
          width: "258px",
          height: "auto",
          minHeight: "70px",
          borderRadius: "8px",
          padding: "8px 16px",
          background: "linear-gradient(0deg, #82E3CC, #82E3CC), linear-gradient(45deg, #8AD8EB 23%, #82E1CC 100%), linear-gradient(45deg, #BCF5A7 23%, #96F5E0 100%)",
          color: "#000",
          fontFamily: "'Urbanist', sans-serif",
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "120%",
          letterSpacing: "0%",
          opacity: "1",
        }}
      />
    </>
  );
};

export default InfoTooltip;
